
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"-739.86 15.445 60 60\" id=\"icon-student\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M-709.86,15.445c-16.568,0-30,13.432-30,30s13.432,30,30,30s30-13.432,30-30S-693.292,15.445-709.86,15.445z\r\n\t M-697.176,54.036c0,3.265-5.76,5.856-12.768,5.856c-7.007,0-12.767-2.591-12.767-5.856V47.03l12.767,5.375l12.768-5.472V54.036z\r\n\t M-692.569,56.436l1.633-4.416c-0.385-0.288-0.577-0.576-0.577-1.056s0.288-0.959,0.768-1.152v-8.064l-19.103,8.256l-22.271-9.504\r\n\tl22.271-9.503l22.271,9.599l-2.208,0.96v8.448c0.479,0.192,0.768,0.575,0.768,1.152c0,0.384-0.288,0.768-0.577,0.959l1.633,4.32\r\n\tH-692.569z\"/> </symbol>";
module.exports = sprite.add(image, "icon-student");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/student.svg
 ** module id = 230
 ** module chunks = 24
 **/